export default class ProcessResult {
  id = null;

  process = null;
  processName = "";
  facility = null;
  facilityName = "";

  stepResults = [];

  users = null;
  username = "";
  finishedOn = null;
  success = false;

  contactedUsers = [];
  contactedUsersNames = [];

  updateable = false;
  manuallyAdded = false;

  rideCount = 0;
  fileNumber = "";

  requiredSignature = false;


}
